import React from 'react';
import { H4, NamedLink } from '../../../components';
import css from './GuideCard.module.css';

/**
 * GuideCard component displays a guide with an image and title
 * @param {Object} listing - The guide listing object
 * @param {Object} intl - React Intl object for translations
 * @param {Object} config - Application configuration
 */
const GuideCard = ({ listing, intl, config }) => {
  const { title } = listing.attributes;
  const firstImage = listing.images && listing.images.length > 0 ? listing.images[0] : null;

  return (
    <NamedLink
      name="ListingPage"
      params={{ id: listing.id.uuid, slug: listing.attributes.title }}
      className={css.guideCard}
    >
      {firstImage && (
        <div className={css.guideImageWrapper}>
          <img
            src={firstImage.attributes.variants['scaled-medium']?.url || firstImage.attributes.variants['default']?.url}
            alt={title}
            className={css.guideImage}
            loading="lazy"
          />
        </div>
      )}
      <div className={css.guideContent}>
        <H4 as="h4" className={css.guideTitle}>
          {title}
        </H4>
      </div>
    </NamedLink>
  );
};

export default GuideCard;